<template>
  <div
    class="site"
    :class="{ debug: debug }"
    data-test-id="signage-site"
    @click="$router.push('/')"
  >
    <warning-message
      v-if="!site.loaded"
      is-loading-message
    >
      {{ $t('status.loading') }}
    </warning-message>
    <div v-else-if="site">
      <warning-message
        v-if="movies.length == 0"
      >
        {{ $t('showing.noShowingsToday') }}
      </warning-message>
      <!-- We have a showtimes-->
      <div
        class="main-display"
        :style="{
          top: marginVertical + 'px ',
          bottom: marginVertical + 'px ',
          left: +marginHorizontal + 'px',
          right: +marginHorizontal + 'px'
        }"
      >
        <div
          v-if="showLogo"
          style="height: 8vh;"
        >
          <img
            class="site-logo"
            :src="site.lightLogoImageUrl"
          >
          <div class="time text-uppercase">
            {{ site.siteTime.format("h:mm a") }}
          </div>
        </div>
        <div class="wrapper">
          <swiper
            :modules="[Pagination, Autoplay]"
            pagination
            :loop="hasMultiSlides"
            :autoplay="signageAutoplay"
            :slides-per-view="isFourColumn || movies.length === 4 ? 4 : 3"
            :slides-per-group="pageMode ? isFourColumn || movies.length === 4 ? 4 : 3 : 1"
            :space-between="30"
            preload-images
            class="swiper"
          >
            <template v-if="movies.length > 4">
              <swiper-slide
                v-for="(slide, index) in moviesSlides"
                :key="index"
              >
                <div
                  class="column justify-between"
                  :style="{ height: showLogo ? '92vh' : '100vh' }"
                >
                  <div
                    v-for="(showings, movieId) in slide"
                    :key="movieId"
                    class="col"
                  >
                    <div class="movie text-left relative-position">
                      <explore-poster
                        :movie="showings[0].movie"
                        use-banner
                        :clean-image-on-posters="cleanImage"
                        show-movie-title-on-posters
                        show-movie-rating
                        is-font-size-responsive
                        display-rating-reason
                        explore-using-dark-mode
                        is-inside-swiper
                        :has-text-wrapped="false"
                        :show-user-buttons="false"
                        :font-size="1.7"
                        :poster-padding="isFourColumn ? 60 : 80"
                        :has-text-centred="false"
                        :highlight-r-rated="highlightRRated"
                        :disable-official-symbol="disableOfficialSymbol"
                      />
                    </div>
                    <div
                      class="showings"
                      :style="`${isComponent || !cleanImage ? 'margin-top: 2vh' : ''}`"
                    >
                      <div
                        class="row inline-block items-start text-left"
                        :class="{
                          [gutterSize]: true,
                          'justify-between': isFourColumn,
                          'justify-start ': !isFourColumn
                        }"
                      >
                        <q-chip
                          v-for="showing in showingsOnDisplay(showings)"
                          :key="showing.id"
                          class="text-uppercase overflow-hidden"
                          :outline="!showing.current"
                          :color="showing.current ? 'grey-4' : showing.past ? '' : 'white'"
                          :text-color="showing.current || showing.past ? '' : 'white'"
                          dense
                          square
                          style="font-size:1.8vw; padding: 0.1vw 0.9vh;"
                          :style="styleForShowing(showing)"
                        >
                          <div class="row full-width justify-between items-center self-center text-center text-bold">
                            <span class="col">{{ showing.siteTime.format("h:mm a") }}</span>
                            <showing-badges
                              v-if="displayShowingBadges"
                              :showing="showing"
                              :color="showing.current ? site.primaryColor : 'white'"
                              size="1.5vw"
                              class="col"
                              style="height: 3vw; border-left: 0.1vw solid;"
                            />
                          </div>
                        </q-chip>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
            </template>
            <template v-else>
              <swiper-slide
                v-for="(showings, movieId) in movies"
                :key="movieId"
              >
                <div
                  class="column justify-between"
                  :style="{ height: showLogo ? '92vh' : '100vh' }"
                >
                  <div
                    class="col"
                  >
                    <div class="movie text-left relative-position">
                      <explore-poster
                        :movie="showings[0].movie"
                        use-banner
                        :clean-image-on-posters="cleanImage"
                        show-movie-title-on-posters
                        show-movie-rating
                        is-font-size-responsive
                        display-rating-reason
                        explore-using-dark-mode
                        is-inside-swiper
                        :has-text-wrapped="false"
                        :show-user-buttons="false"
                        :font-size="1.7"
                        :poster-padding="isFourColumn ? 60 : 80"
                        :has-text-centred="false"
                        :highlight-r-rated="highlightRRated"
                        :disable-official-symbol="disableOfficialSymbol"
                      />
                    </div>
                    <div
                      class="showings"
                      :style="`${isComponent || !cleanImage ? 'margin-top: 2vh' : ''}`"
                    >
                      <div
                        class="row inline-block justify-start items-start"
                        :class="gutterSize"
                      >
                        <q-chip
                          v-for="showing in showings"
                          :key="showing.id"
                          class="text-uppercase overflow-hidden"
                          :outline="!showing.current"
                          :color="showing.current ? 'grey-5' : 'white'"
                          :text-color="showing.current ? '' : 'white'"
                          dense
                          square
                          style="font-size:1.8vw; border-width: 0.1vw; padding: 0.1vw 0.9vh;"
                          :style="styleForShowing(showing)"
                        >
                          <div class="row full-width justify-between items-center self-center text-bold">
                            <span class="col">{{ showing.siteTime.format("h:mm a") }}</span>
                            <showing-badges
                              v-if="displayShowingBadges"
                              :showing="showing"
                              :color="showing.current ? site.primaryColor : 'white'"
                              size="1.5vw"
                              class="col"
                              style="height: 3vw; border-left: 0.1vw solid;"
                            />
                          </div>
                        </q-chip>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
            </template>
          </swiper>
        </div>
      </div>
    </div>
    <warning-message
      v-else-if="errorOccurred"
    >
      A network error occurred
    </warning-message>
    <warning-message
      v-else
    >
      {{ `Unknown Site - ${$route.params.id}` }}
    </warning-message>
  </div>
</template>

<script>
import ExplorePoster from 'src/modules/consumer/components/ExplorePoster'
import SwiperModulesMixin from 'src/modules/consumer/components/mixins/SwiperModulesMixin'
import ShowingBadges from 'src/modules/signage/components/ShowingBadges'
import WarningMessage from 'src/modules/signage/components/WarningMessage'
import ShowingsSignageConfigurationMixin from 'src/modules/signage/mixins/ShowingsSignageConfigurationMixin'
import { inject } from 'vue'
export default {
  name: 'ShowingsBanner',
  components: {
    ExplorePoster,
    WarningMessage,
    ShowingBadges
  },
  mixins: [ShowingsSignageConfigurationMixin, SwiperModulesMixin],
  models: {
    site: {
      fields: ['id', 'name', 'primaryColor', 'lightLogoImage', 'timeZone', 'signageConfig', 'migratedTo'],
      todaysShowings: {
        movie: 'default',
        screen: 'default',
        showingBadges: 'default'
      },
      variables () {
        return {
          id: this.siteId
        }
      },
      immediate: true
    }
  },
  props: {
    isComponent: {
      type: Boolean,
      required: false,
      default: false
    },
    overrideSiteId: {
      type: Number,
      required: false,
      default: null
    },
    overrideCover: {
      type: Boolean,
      required: false,
      default: false
    },
    interval: {
      type: Number,
      required: false,
      default () {
        const route = inject('route')
        return parseInt(route?.query?.interval) || 5000
      }
    },
    pageMode: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return route?.query?.mode === 'page'
      }
    },
    cleanImage: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return route?.query && route.query['clean-image'] === 'true'
      }
    },
    showAllAvailableShowtimes: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return route?.query && route.query['show-all-available-showtimes'] === 'true'
      }
    },
    displayShowingBadges: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return (route?.query && route.query['display-showing-badges'] === 'true') || false
      }
    }
  },
  data () {
    return {
      errorOccurred: false
    }
  },
  computed: {
    titleClassIds () {
      if (!this.$route.query['title-class-ids']) return

      return _.map(this.$route.query['title-class-ids'].split(','), parseInt)
    },
    hidePast () {
      return this.$route.query['hide-past'] === 'true'
    },
    movies () {
      if (!this.site) return

      return _(this.site.todaysShowings.data)
        .filter(showing => !this.titleClassIds || _.includes(this.titleClassIds, showing.movie.titleClassId))
        .filter(showing => !this.hidePast || !showing.past)
        .groupBy('movie.id')
        .sortBy(showings => -showings.length) // Second priority is number of showings
        .sortBy(showings => showings[0].screen.displayOrder) // First priority is what screen it is in
        .value()
    },
    moviesSlides () {
      if (!this.movies) return
      // GROUP EACH TWO MOVIES INTO ARRAY TO CREATE 2 MOVIES IN A COLUMN LAYOUT
      return this.movies
        .reduce((accumulator, currentValue, currentIndex, array) => {
          if (currentIndex % 2 === 0) {
            accumulator.push(array.slice(currentIndex, currentIndex + 2))
          }
          return accumulator
        }, [])
    },
    cover () {
      return this.overrideCover || this.$route.query.cover || false
    },
    siteId () {
      return this.overrideSiteId || this.$route.params?.siteId
    },

    gutterSize () {
      if (!this.isFourColumn) {
        if (this.$q.screen.width > 3500) return 'q-gutter-x-lg'
        if (this.$q.screen.width > 2500) return 'q-gutter-x-md'
        return 'q-gutter-x-sm'
      }
      if (this.$q.screen.width > 3500) return 'q-gutter-x-lg'
      if (this.$q.screen.width > 2500) return 'q-gutter-x-md'

      return ''
    },
    isFourColumn () {
      return this.movies.length > 6
    },
    hasMultiSlides () {
      return this.isFourColumn && this.movies.length > 8
    }
  },
  async mounted () {
    this.moviesIntervalId = setInterval(() => {
      this.site.fetch(true)
    }, 10 * 60 * 1000)

    await this.site.fetch()

    if (this.$signage) {
      // Fetching the site when in the app mode of digital-signage, sets the site_id cookie
      // This will reload the configuration data after being authenticated
      this.$handleAuthChange()
    }
  },
  beforeUnmount () {
    if (this.timeIntervalId) clearInterval(this.timeIntervalId)

    if (this.moviesIntervalId) clearInterval(this.moviesIntervalId)
  },
  methods: {
    styleForShowing (showing) {
      const style = []
      const hasShowingBadges = this.displayShowingBadges && _.some(showing.showingBadges.data, badge => badge.displayOnSignage)
      if (hasShowingBadges) {
        style.push('width: 90%')
      } else if (this.isFourColumn) {
        style.push('width: 40%')
      } else {
        style.push('width: 26%')
      }
      if (showing.past) {
        style.push('text-decoration: line-through; ' + 'color: ' + this.$lightenColor(this.site.primaryColor, 40) + ' !important ; border: 0.1vw solid ' + this.$lightenColor(this.site.primaryColor, 40))
      } else if (showing.current) {
        style.push('border: 0.1vw solid; color: ' + this.site.primaryColor)
      } else {
        style.push('border: 0.1vw solid #ffffff')
      }
      return style.join(';')
    },
    showingsOnDisplay (showings) {
      if (this.showAllAvailableShowtimes) return showings
      // group every 2 showings to create 2 row in one slide view
      return showings.filter(showing => !showing.past).slice(0, 4)
    }
  }
}
</script>

<style scoped>
.site {
  background-color: #161616;
  color: #fff;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.site.debug {
  border: solid 1px red;
}
.main-display {
  position: absolute;
  display: flex;
  flex-direction: column;
}

.site-logo {
  max-width: 50vw;
  max-height: 6vh;
}

.time {
  position: absolute;
  top: 1vh;
  right: 1vh;
  font-size: 3vh;
}

.debug .movie-container > div {
  border: solid 1px red;
}
.showings {
  flex-grow: 3;

  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
</style>
